import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'bypassSecurity'
})
export class BypassSecurityPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string, type: 'html' | 'resourceUrl' = 'html'): SafeHtml | SafeResourceUrl {
    if (!type || type === 'html') {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    if (type === 'resourceUrl') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }
    throw new Error(`Unknown security bypass type: ${type}`);
  }
}